export const PARAMETERS_TABS = {
  parameters: 'parameters',
  viewExportImport: 'viewExportImport',
  notificationSettings: 'notificationSettings',
  widgetTemplates: 'widgetTemplates',
};
